import React from 'react';
import { LegalPage } from './LegalPage';

const FALLBACK_HTML = `
<h1>Cookie Policy</h1>
<p><em>Last updated: 24/04/2026</em></p>

<p>This website uses cookies and similar technologies to improve your browsing experience, analyse website traffic and, where applicable, track affiliate links to external booking platforms.</p>

<h2>What are cookies?</h2>
<p>Cookies are small text files stored on your device when you visit a website.</p>

<h2>Types of cookies we may use</h2>

<h3>Essential cookies</h3>
<p>These cookies are necessary for the website to work properly.</p>

<h3>Analytics cookies</h3>
<p>These help us understand how visitors use the website, such as which pages are visited most often.</p>

<h3>Affiliate cookies or tracking links</h3>
<p>Some external links may include affiliate tracking. This means that if you click a link and make a booking on an external platform, we may earn a commission at no extra cost to you.</p>

<h3>Third-party cookies</h3>
<p>External platforms such as Viator, GetYourGuide or analytics providers may use their own cookies when you visit their websites. Their use of cookies is governed by their own cookie policies.</p>

<h2>Managing cookies</h2>
<p>You can accept, reject or manage non-essential cookies through the cookie banner or your browser settings.</p>

<h2>Contact</h2>
<p>For questions about this Cookie Policy, contact us at: <a href="mailto:info@sitgesvibes.com">info@sitgesvibes.com</a></p>
`;

export function CookiePolicyPage() {
  return (
    <LegalPage
      contentKey="cookie_policy"
      fallbackHtml={FALLBACK_HTML}
      testId="cookie-policy-page"
      titleKey="legal_cookie_policy"
      seoTitle="Cookie Policy | SitgesVibes"
      seoDescription="How SitgesVibes uses cookies and similar technologies to improve your browsing experience and analyse website traffic."
    />
  );
}

export default CookiePolicyPage;
